var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstruct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("path", {
    d: "M5,13.7a4,4,0,0,0-4,4v5.5H9V17.7A4,4,0,0,0,5,13.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 14.196,
    x2: 3,
    y2: 7.932
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7.932,
    x2: 7,
    y2: 14.196
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.696,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.525,
    cy: 3.558,
    r: 2.754
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.892,
    y1: 2.247,
    x2: 7.052,
    y2: 3.508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.946,
    y1: 6.265,
    x2: 14.739,
    y2: 5.172
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.594,
    y1: 6.312,
    x2: 16.833,
    y2: 9.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.164,
    y1: 9.028,
    x2: 18.925,
    y2: 6.125
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18.196,
    x2: 9,
    y2: 18.196
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.65 9.293 18.025 9.122 20.274 8.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.272,
    y1: 12.124,
    x2: 18.025,
    y2: 9.122
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 23.196,
    x2: 23,
    y2: 23.196
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.445,23.2V21.085a.857.857,0,0,1,.868-.845h7.818a.857.857,0,0,1,.869.845V23.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.182 20.24 18.222 14.24 21.263 20.24 15.182 20.24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.624,
    r: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.44,
    y1: 10.505,
    x2: 22.606,
    y2: 9.737
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.598,
    y1: 12.873,
    x2: 22.569,
    y2: 13.615
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.769,
    y1: 11.076,
    x2: 13.454,
    y2: 10.606
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.177,
    y1: 13.413,
    x2: 14.41,
    y2: 14.364
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruct);
export default __webpack_public_path__ + "static/media/construct.14535b26.svg";
export { ForwardRef as ReactComponent };